import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, radius, mq, motion, font } = theme.custom;
    return {
        container: { maxHeight: 'calc(100vh - 330px)', minHeight: 240 },
        row: { cursor: 'pointer' },
        orderCell: { minWidth: 200 },
        orderLink: {
            fontWeight: 600,
            color: color.text.primary,
            whiteSpace: 'nowrap',
            textDecoration: 'none',
            borderRadius: 4,
            '&:hover': { color: color.primary.main, textDecoration: 'underline' },
        },
        orderEmail: { fontSize: 12, color: color.text.secondary, marginTop: 2, overflowWrap: 'anywhere' },
        dateCell: { whiteSpace: 'nowrap' },
        capitalize: { textTransform: 'capitalize', whiteSpace: 'nowrap' },
        shop: { fontSize: 12, fontFamily: font.mono, maxWidth: 180, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
        numeric: { textAlign: 'right', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' },
        openButton: { color: color.text.secondary, '&:hover': { color: color.primary.main } },
        cards: { display: 'flex', flexDirection: 'column', gap: 10, padding: 12 },
        card: {
            display: 'block',
            width: '100%',
            textAlign: 'left',
            padding: 14,
            borderRadius: radius.md,
            border: `1px solid ${color.border}`,
            backgroundColor: color.surfaceRaised,
            fontFamily: 'inherit',
            transitionProperty: 'background-color, border-color',
            transitionDuration: motion.fast,
            '&:hover': { borderColor: color.primary.main },
        },
        cardTop: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 10 },
        cardGrid: { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '8px 12px', fontSize: 13, [mq.xs]: { gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' } },
        cardLabel: { fontSize: 11, color: color.text.secondary, display: 'block', marginBottom: 2 },
        cardValue: { fontVariantNumeric: 'tabular-nums', color: color.text.primary, overflowWrap: 'anywhere' },
    };
});
